import { render, staticRenderFns } from "./ChatSelectedWrapper.vue?vue&type=template&id=15210282&scoped=true&lang=pug"
import script from "./ChatSelectedWrapper.vue?vue&type=script&lang=js"
export * from "./ChatSelectedWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15210282",
  null
  
)

export default component.exports